import member from './root.vue'
import MainNav from './main_nav.vue'
import memberList from './member_list/router'
import memberDetail from './member_detail/router'
import memberImport from './member_import/router'
import memberImportOperateDetail from './member_import_operate_detail/router'
import rechargeRecord from './recharge_record/router'
import memberWelfare from './member_welfare/router'

const route = {
    path: 'member',
    component: member,
    children: [{
        path: '',
        redirect: 'nav'
    }, {
        path: 'nav',
        component: MainNav,
        children: [{
            path: '',
            redirect: memberList.path
        },
            memberList,
            rechargeRecord,
            memberWelfare
        ]
    },
        memberDetail,
        memberImport,
        memberImportOperateDetail
    ]
}

export default route
